import MyOrders from "../components/student/MyOrders"
import StudentDashboardLayout from "../components/StudentDashboardLayout";
function StudentMyOrdersPage(){
  return(
    <StudentDashboardLayout>
    <MyOrders/></StudentDashboardLayout>
  )

}
export default StudentMyOrdersPage